// services/api/health.ts
import { useFirebaseStore } from '@/stores/firebase'
import type { AppHealthStatus } from '@/types/all'
import { baseUrl } from '@/types/api'

export async function apiHealthStatus() {
  try {
    const response = await fetch(`${baseUrl}/health/public`)
    if (!response.ok) throw new Error(`Health check failed: ${response.status}`)
    return await response.json()
  } catch (error) {
    console.error('Health check error:', error)
    throw error
  }
}

export async function apiProtectedHealthStatus() {
  const firebaseStore = useFirebaseStore()
  const authHeaders = await firebaseStore.getAuthHeadersForAPI()
  try {
    const response = await fetch(`${baseUrl}/health/protected`, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
      },
    })
    if (!response.ok) throw new Error(`Protected health check failed: ${response.status}`)
    return await response.json()
  } catch (error) {
    throw error
  }
}

export async function dbStatus() {
  const firebaseStore = useFirebaseStore()
  const authHeaders = await firebaseStore.getAuthHeadersForAPI()
  try {
    const response = await fetch(`${baseUrl}/health/db`, {
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
      },
    })
    if (!response.ok) throw new Error(`DB health check failed: ${response.status}`)
    return await response.json()
  } catch (error) {
    throw error
  }
}

export async function firebaseStatus(): Promise<AppHealthStatus> {
  const firebaseStore = useFirebaseStore()
  return firebaseStore.healthStatus
}
